import * as actionTypes from './types';
import { updateObject } from '../../utility';

const initialState = {
  metaData: {},
  columnTotal: Array.from({ length: 2 }, () => 0),
  totalArea: {},
  fertiliserOptions: [],
};

const fertiliserReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FERTILISER_METADATA_SUCCESS: return setMetaDataSuccess(state, action);
    case actionTypes.GET_FERTILISER_METADATA_FAIL: return setMetaDataFail(state, action);
    case actionTypes.RESET_FERTILISER_METADATA: return resetFertiliserMetaData(state, action);
    case actionTypes.GET_FERTILISER_FORM_DATA_SUCCESS: return setFormDataSuccess(state, action);
    case actionTypes.GET_FERTILISER_FORM_DATA_FAIL: return setFormDataFail(state, action);
    case actionTypes.SET_FERTILISER_FORM_DATA: return setFormData(state, action);
    case actionTypes.RESET_FERTILISER_ALL_DATA: return resetFormData(state, action);
    case actionTypes.GET_FERTILISER_OPTIONS_SUCCESS: return setFertiliserOptionsSuccess(state, action);
    case actionTypes.GET_FERTILISER_OPTIONS_FAIL: return setFertiliserOptionsFail(state, action);
    default:
      return state;
  }
}

const setMetaDataSuccess = (state, action) => {
  const updatedState = {
    metaData: action.payload,
  }
  return updateObject(state, updatedState);
}

const setMetaDataFail = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const resetFertiliserMetaData = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const setFormDataSuccess = (state, action) => {
  const updatedState = {
    initialFormData: action.payload,
    currentFormData: action.payload,
  }
  return updateObject(state, updatedState);
}

const setFormDataFail = (state, action) => {
  const updatedState = {
    metaData: {},
  }
  return updateObject(state, updatedState);
}

const setFormData = (state, action) => {
  const { sectorId, formData } = action.payload;
  const updatedState = {
    currentFormData: {
      ...state.currentFormData,
      [sectorId]: {
        ...formData
      }
    },
  }
  return updateObject(state, updatedState);
}

const setFertiliserOptionsSuccess = (state, action) => {
  const updatedState = {
    fertiliserOptions: action.payload,
  }
  return updateObject(state, updatedState);
}

const setFertiliserOptionsFail = (state, action) => {
  const updatedState = {
    fertiliserOptions: [],
  }
  return updateObject(state, updatedState);
}

const resetFormData = (state, action) => {
  const updatedState = {
    currentFormData: state.initialFormData,
  }
  return updateObject(state, updatedState);
}


export default fertiliserReducer;
